import { MobileWarningModal } from '@/components/Elements/MobileWarningModal/MobileWarningModal';
import { UpgradeModal } from '@/components/UpgradeModal';
import { ForceLoginState } from '@/providers/ForceLoginState';
import { Outlet, useLocation } from 'react-router';

const shouldShowMobileWarning = (pathname: string) => {
  if (pathname.startsWith('/setup')) return false;
  if (pathname === '/settings/profile') return false;

  return true;
};

export const PrivateApp = () => {
  const { pathname } = useLocation();

  return (
    <ForceLoginState type="loggedInOnly">
      {shouldShowMobileWarning(pathname) && <MobileWarningModal />}
      <UpgradeModal />
      <Outlet />
    </ForceLoginState>
  );
};
